import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox';
import style from './style.module.less';
import { noop } from 'ui-components/default-props/noop';

export const HeaderRow = ({
  onToggleAllChecked = noop,
  hasToggleAllChecked = false,
  showActionableColumns = true,
  showReadyToPickTableLayout = false,
  showSkuCell,
}) => {
  return (
    <div className={style['header-row']}>
      {showActionableColumns && (
        <div className={style['header-cell']}>
          <Checkbox checked={hasToggleAllChecked} onChange={onToggleAllChecked} />
        </div>
      )}
      <div className={style['header-cell']}>
        <FormattedMessage defaultMessage='Order #' description='headerRow.shipmentNumber' id='PhuRkf' />
      </div>
      {showReadyToPickTableLayout && !showSkuCell && (
        <div className={style['header-cell']}>
          <FormattedMessage defaultMessage='Date' description='headerRow.date' id='QDJbTe' />
        </div>
      )}
      {showSkuCell && (
        <div className={style['header-cell']}>
          <FormattedMessage defaultMessage='SKU' description='headerRow.sku' id='2EjCvT' />
        </div>
      )}
      {showReadyToPickTableLayout && showSkuCell ? (
        <div className={style['header-cell']}>
          <FormattedMessage defaultMessage='Item Name' description='headerRow.itemName' id='Or+yXl' />
        </div>
      ) : (
        <div className={style['header-cell']}>
          <FormattedMessage defaultMessage='Problem' description='headerRow.problem' id='iGaVSK' />
        </div>
      )}
      {showActionableColumns && (
        <div className={style['header-cell']}>
          <FormattedMessage defaultMessage='Remove from Batch' description='headerRow.removeFromBatch' id='zQIDD3' />
        </div>
      )}
    </div>
  );
};

HeaderRow.propTypes = {
  onToggleAllChecked: PropTypes.func,
  hasToggleAllChecked: PropTypes.bool,
  showActionableColumns: PropTypes.bool,
  showReadyToPickTableLayout: PropTypes.bool,
};
